import { RoutesService, eLayoutType } from '@abp/ng.core';
import { APP_INITIALIZER } from '@angular/core';

export const GALLERY_SHARE_ROUTE_PROVIDER = [
  { provide: APP_INITIALIZER, useFactory: configureRoutes, deps: [RoutesService], multi: true },
];

function configureRoutes(routes: RoutesService) {
  return () => {
    routes.add([
      {
        path: '/share/gallery',
        name: 'Gallery Share',
        layout: eLayoutType.empty,
        invisible: true, // Don't show in menu
      },
    ]);
  };
}
